
import {Options, Vue} from "vue-class-component";
import {AppStore, DataStore, EventStore, LocaleStore} from "./store";
import {translate} from '@/helpers/locale-helper';

import version from '@/version';
import BusEvent from "../../shared/js/BusEvent";
import Tutorial from "@/components/Tutorial/Tutorial.vue";
import TutorialTester from "@/components/Tutorial/TutorialTester.vue";
import Outro from "@/components/Outro/Outro.vue";


@Options({
  components: {
    Tutorial,
    TutorialTester,
    Outro
  }
})
export default class App extends Vue {
  translate(message: string): string {
    return translate(this.$i18n.locale, message);
  }

  mounted() {
    // console.log('vimy-app-version: ', version);
    // console.log('VERSION DU 2022-03-11 11:50: ');
    this.loadLocale();
    LocaleStore.fetchLocales();
    DataStore.fetchData();
    EventStore.registerAllListenners();

    this.$watch('$i18n.locale', (value: string, legacyValue: string) => {
      document.dispatchEvent(new BusEvent(BusEvent.EVENTS.LANG, {
        lang: value
      }));
    });

    AppStore.$watch(t => t.openCredits, (value, _) => {
      this.$router.push({path: 'credits'});
    });


  }

  private loadLocale() {
    const locale = localStorage.getItem('locale');
    if (locale)
      this.$i18n.locale = locale;
  }
}
